class ProductDetailReview extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setupObserver()
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this.observer.disconnect()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.onClick.bind(this))
  }

  /**
   * Sets up a MutationObserver to watch for changes in the target element. Calls
   * the formatReviewCount function whenever changes are detected.
   *
   * @function observer
   */
  setupObserver () {
    this.observer = new MutationObserver(() => {
      this.formatReviewCount()
    })

    this.observer.observe(this, {
      childList: true,
      subtree: false,
    })
  }

  formatReviewCount () {
    const countEl = this.querySelector('.text-m')
    if (!countEl) return

    const reviewCount = countEl.textContent?.split(' ')?.[0]
    const reviewText = isNaN(reviewCount)
      ? countEl.textContent
      : Number(countEl.textContent?.split(' ')?.[0] || 0)
    countEl.textContent = `(${reviewText})`
  }

  onClick (e) {
    e.preventDefault()

    const boundingRect = this.reviewsEl?.getBoundingClientRect()
    const distanceFromTopOfPage = window.scrollY + boundingRect.top
    const announcementBar = document.querySelector('header-announcement-bar')
    const announcementBarHeight =
      announcementBar !== null ? announcementBar.offsetHeight : 0
    const headerHeight = document.querySelector('.hd-Header').offsetHeight
    const combinedHeight = announcementBarHeight + headerHeight

    window.BAO.Utils.scrollToY(distanceFromTopOfPage - combinedHeight)
  }

  get reviewsEl () {
    return document.querySelector(
      '[data-product-detail-reviews-external-el="reviews"]',
    )
  }
}

if (!customElements.get('product-detail-review')) {
  customElements.define('product-detail-review', ProductDetailReview)
}
